import React from 'react';
import PropTypes from 'prop-types';
import nanoid from 'nanoid';

export const TYPE_FILTERS_NAME = 'Types';

class NewsFeedTypeFilter extends React.Component {
    renderControls() {
        const { config, selectedFilters } = this.props;

        return config.options.map((option) => {
            const id = nanoid();
            return (
                <li key={nanoid()}>
                    <div className="news-feed-type news-feed-type--icon">
                        <input
                            className="news-feed-type__native visually-hidden"
                            id={id}
                            type="checkbox"
                            value={option.value}
                            checked={selectedFilters.indexOf(option.value) !== -1}
                            onChange={(event) =>
                                this.props.onFiltersChange(
                                    TYPE_FILTERS_NAME,
                                    option.value,
                                    event.target.checked
                                )
                            }
                        />
                        <label className="news-feed-type__label" htmlFor={id}>
                            <svg className="news-feed-type__icon icon" width="15" height="15">
                                <use xlinkHref="#icon-watch"></use>
                            </svg>
                            <span className="news-feed-type__text">{option.text}</span>
                        </label>
                    </div>
                </li>
            );
        });
    }

    render() {
        return (
            <ul>
                {this.renderControls()}
            </ul>
        );
    }
}

NewsFeedTypeFilter.propTypes = {
    config: PropTypes.object.isRequired,
    selectedFilters: PropTypes.array.isRequired,
    onFiltersChange: PropTypes.func.isRequired
};

export default NewsFeedTypeFilter;
